import { render, staticRenderFns } from "./CustomFormSubmission.vue?vue&type=template&id=dbe56848&"
import script from "./CustomFormSubmission.vue?vue&type=script&lang=js&"
export * from "./CustomFormSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports